// src/utils/displayPrefs.js — per-device display preferences (localStorage).
// These are intentionally client-side only: they tune how the app looks on THIS
// device (text size, chat wallpaper) and shouldn't sync or need the server.

const FONT_KEY   = 'tt_font_scale';
const DOODLE_KEY = 'tt_chat_doodle';

// ── Text size ───────────────────────────────────────────────────────────────
// TEXT-ONLY scaling. In the native app this uses the WebView's text-zoom
// (the same mechanism as Android's system font size — layout keeps its size,
// only text grows). In a plain browser, where that API doesn't exist, we fall
// back to a page zoom.
export const FONT_SCALES = [
  { key: 0.9,  label: 'Small' },
  { key: 1,    label: 'Default' },
  { key: 1.15, label: 'Large' },
  { key: 1.3,  label: 'Extra Large' },
];

export const getFontScale = () => {
  const v = parseFloat(localStorage.getItem(FONT_KEY));
  return Number.isFinite(v) && v >= 0.8 && v <= 1.5 ? v : 1;
};

export const applyFontScale = async (scale) => {
  const s = scale || 1;
  try {
    const { isNativeApp } = require('./platform');
    if (isNativeApp()) {
      const { TextZoom } = await import('@capacitor/text-zoom');
      await TextZoom.set({ value: s });      // text only — layout untouched
      document.documentElement.style.zoom = ''; // clear any legacy page zoom
      return;
    }
  } catch { /* plugin absent (old APK) — fall back below */ }
  try { document.documentElement.style.zoom = String(s); } catch { /* older engine */ }
};

export const setFontScale = (scale) => {
  try { localStorage.setItem(FONT_KEY, String(scale)); } catch { /* storage full/blocked */ }
  applyFontScale(scale);
};

// ── Chat doodle wallpaper ────────────────────────────────────────────────────
export const getChatDoodle = () => localStorage.getItem(DOODLE_KEY) !== 'off';
export const setChatDoodle = (on) => {
  try { localStorage.setItem(DOODLE_KEY, on ? 'on' : 'off'); } catch { /* ignore */ }
};
